export default "__VITE_ASSET__GJNHupB5__";